<template>
  <div class="v-stack h-stretch gap-3">
    <div class="h-stack h-space-between">
      <div class="h-stack h-start gap-3">
        <label>Show:</label>
        <select v-model="filter" style="width: 130px">
          <option value="">All</option>
          <option value="workdays">Workdays</option>
          <option value="bonus">Bonus</option>
          <option value="advance">Advance</option>
          <option value="fine">Fine</option>
        </select>
      </div>
      <div class="h-stack h-start gap-3">
        <label>Details:</label>
        <input v-model="showWorkHours" type="checkbox" />
        <label>Signed:</label>
        <input v-model="signed" type="checkbox" />
        <label>Unsigned:</label>
        <input v-model="unsigned" type="checkbox" />
        <label>Canceled:</label>
        <input v-model="canceled" type="checkbox" />
      </div>
    </div>
    <div class="card light">
      <div class="content">
        <div class="v-stack gap-3">
          <a>Period overview</a>
          <div class="pane-horizontal gap-3">
            <div class="text-right">Unsigned:</div>
            <div class="text-left">{{ unsignedCount }}</div>
          </div>
          <div class="pane-horizontal gap-3">
            <div class="text-right">Money:</div>
            <div class="text-left">{{ format.currency(revenue) }} Kč</div>
          </div>
          <div class="pane-horizontal gap-3">
            <div class="text-right">Hours:</div>
            <div class="text-left">{{ Math.round(hours) }}</div>
          </div>
        </div>
      </div>
    </div>
    <TableWorkdays
      :loading="loading"
      :pageable="true"
      :workdays="workdaysFiltered"
      :oneTimePay="oneTimePayFiltered"
      :showWorkHours="showWorkHours"
      v-on:refresh="refresh()"
      :showName="true"
      :allowSign="$store.state.accessLevel > 9 ? true : false"
    >
    </TableWorkdays>
  </div>
</template>

<script>
import TableWorkdays from "@/components/TableWorkdays.vue";
import utils from "@/utils.js";
import { mapActions } from "vuex";

export default {
  data() {
    return {
      filter: "",
      signed: true,
      unsigned: true,
      canceled: true,
      format: utils.format,
      showWorkHours: false,
      workdays: [],
      oneTimePay: [],
      loading: false,
    };
  },
  components: {
    TableWorkdays,
  },
  props: {
    userFilter: {
      type: String,
      default: () => "",
    },
    period: {
      type: String,
      default: () => "",
    },
    year: {
      type: String,
      default: () => "",
    },
    month: {
      type: Number,
      default: () => "",
    },
    startDate: {
      type: String,
      default: () => "",
    },
    endDate: {
      type: String,
      default: () => "",
    },
  },
  watch: {
    userFilter() {
      this.refresh();
    },
    period() {
      this.refresh();
    },
    year() {
      this.refresh();
    },
    month() {
      this.refresh();
    },
    startDate() {
      this.refresh();
    },
    endDate() {
      this.refresh();
    },
  },
  computed: {
    workdaysFiltered() {
      // catch workdays
      let workdays = this.workdays;

      // apply filters

      if (!this.signed) {
        workdays = workdays.filter((item) => item.state != "signed");
      }
      if (!this.unsigned) {
        workdays = workdays.filter((item) => item.state != "created");
      }
      if (!this.canceled) {
        workdays = workdays.filter((item) => item.state != "canceled");
      }

      if (this.filter == "" || this.filter == "workdays") {
        return workdays;
      }

      return [];
    },
    oneTimePayFiltered() {
      // catch oneTimePay
      let oneTimePay = this.oneTimePay;

      // apply filters
      if (!this.signed) {
        oneTimePay = oneTimePay.filter((item) => item.state != "signed");
      }
      if (!this.unsigned) {
        oneTimePay = oneTimePay.filter((item) => item.state != "created");
      }
      if (!this.canceled) {
        oneTimePay = oneTimePay.filter((item) => item.state != "canceled");
      }

      if (this.filter == "workdays") {
        return [];
      } else {
        if (this.filter == "bonus") {
          return oneTimePay.filter((item) => item.amount > 0);
        }

        if (this.filter == "advance") {
          return oneTimePay.filter(
            (item) => item.amount < 0 && item.fine != true
          );
        }

        if (this.filter == "fine") {
          return oneTimePay.filter(
            (item) => item.amount < 0 && item.fine == true
          );
        }
      }

      return oneTimePay;
    },
    hours() {
      let workdays = this.workdays;
      workdays = workdays.filter((item) => item.state == "signed");

      return utils.finance.workdayHours(workdays);
    },
    unsignedCount() {
      let workdays = this.workdays;

      workdays = workdays.filter((item) => item.state == "created");

      let oneTimePay = this.oneTimePay;

      oneTimePay = oneTimePay.filter((item) => item.state == "created");

      return workdays.concat(oneTimePay).length;
    },
    revenue() {
      // catch workdays
      let workdays = this.workdays;

      // apply filters
      workdays = workdays.filter((item) => item.state == "signed");

      // catch oneTimePay

      let oneTimePay = this.oneTimePay;

      // apply filters
      oneTimePay = oneTimePay.filter((item) => item.state == "signed");

      return utils.finance.revenue(workdays, oneTimePay);
    },
  },
  methods: {
    ...mapActions(["getUserHours"]),
    refresh() {
      this.loading = true;
      this.getUserHours({
        userFilter: this.userFilter,
        period: this.period,
        year: this.year,
        month: this.month,
        startDate: this.startDate,
        endDate: this.endDate,
      })
        .then((data) => {
          this.workdays = data.workdays;
          this.oneTimePay = data.oneTimePay;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style scoped>
label,
input {
  align-self: center;
}
</style>
